<script>
import container from '@/js/util/accordion';
import dynamicComponent from '@/js/mixins/dynamic-component';

export default {
    name: 'AccordionContainerPanel',
    defaultTag: 'div',
    mixins: [dynamicComponent],
    inject: { container },
    props: {
        transition: {
            type: String,
            default: 'transition',
        },
        transitionProps: {
            type: Object,
            default: () => ({}),
        },
        mode: {
            type: String,
            default: 'show',
            validator: (value) => ['if', 'show'].includes(value),
        },
        anchor: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            required: true,
        },
        initiallyExpanded: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            expanded: this.initiallyExpanded || location.hash == ("#"+this.anchor),
            shouldHighlight: location.hash == ("#"+this.anchor),
        };
    },
    computed: {
        button() {
            return this.container.buttons.find(this.isLabelledbyButton);
        },
        role() {
            const containerVm = this.container;

            if (containerVm.multiple && containerVm.panels.length > 6) {
                return null;
            }

            return 'region';
        },
        ariaLabelledby() {
            return this.button ? this.button.id : null;
        },
    },
    created() {
        this.$on('toggle', this.toggle);

        this.container.$emit('create:panel', this);

    },
    mounted() {

        this.hashToggle();
        window.addEventListener("hashchange", this.hashToggle);

        if(this.shouldHighlight){
                document.getElementById(this.id).parentNode.firstChild.classList.add("accordion__highlight");
                            
            setTimeout(() => {
                document.getElementById(this.id).parentNode.firstChild.classList.add("accordion__x__highlight");
                
            }, 1500);

        }
    },
    methods: {
         hashToggle() {

            var href = location.href;
            var end = href.split("#")[1];
            end = "#" + end;
            var endTarget = this.$el.querySelector(end);
            if(endTarget){

                this.$el.querySelectorAll("a:not(a[href])").forEach(element => {
                    element.setAttribute("tabindex", "-1")
                });
                if(!this.expanded){
                    this.toggle();
                }
                setTimeout(function(){
                    endTarget.focus();
                }, 300);
                

                endTarget.parentElement.classList.add('accordion__highlight');
                                
                setTimeout(() => {
                    endTarget.parentElement.classList.add('accordion__x__highlight');
                }, 1500);
                setTimeout(() => {
                    endTarget.parentElement.classList.remove('accordion__highlight');
                    endTarget.parentElement.classList.remove('accordion__x__highlight');

                }, 1600);
            }


        },

        toggle() {
            this.expanded = !this.expanded;

            this.$nextTick(() => {
                this.$emit(this.expanded ? 'open' : 'close');
            });

            setTimeout(() => {
                const alerts = document.getElementsByClassName('alert-bar');
                let alertHeight = 0;
                if (alerts !== undefined && alerts.length !== 0) {
                    for (let i = 0; i < alerts.length; i=i+1) {
                        alertHeight += alerts[i].offsetHeight;
                    }

                    const openNavPanel = document.getElementsByClassName('nav__secondary-small open');
                    if (openNavPanel !== undefined && openNavPanel.length !== 0) {
                        openNavPanel[0].style.maxHeight = `calc(100vh - ${alertHeight + 72}px)`;
                    } else {
                        const closedNavPanel = document.getElementsByClassName('nav__secondary-small');
                        if (closedNavPanel !== undefined && closedNavPanel.length !== 0) {
                            closedNavPanel[0].style.maxHeight = '52px';
                        }
                    }
                }
            }, 100);
        },
        handleKeydown(event) {
            if (!event.ctrlKey) {
                return;
            }

            const eventToEmit = {
                PageUp: 'focus:header.current',
                PageDown: 'focus:header.next',
            }[event.key];

            if (!eventToEmit) {
                return;
            }

            event.preventDefault();

            this.container.$emit(eventToEmit);
        },
        isLabelledbyButton({ controls }) {
            return this.id === controls;
        },
        createEl(createElement, data) {
            if (!(this.mode === 'show' || this.expanded)) {
                return undefined;
            }

            return createElement(this.is, data, this.$slots.default);
        },
    },
    render(createElement) {
        const { id, ariaLabelledby, role } = this;
        const data = {
            attrs: { id, 'aria-labelledby': ariaLabelledby, role },
            on: { keydown: this.handleKeydown },
        };

        if (this.mode === 'show') {
            data.directives = [{
                name: 'show',
                value: this.expanded,
            }];
        }

        const el = this.createEl(createElement, data);

        if (this.transition) {
            return createElement(
                this.transition,
                { props: this.transitionProps },
                [el],
            );
        }

        return el;
    },
};
</script>



// WEBPACK FOOTER //
// src/components/accordion/AccordionContainerPanel.vue